import {createApp} from 'vue'
import App from './App.vue'
import DhForVue, {shareTheme} from '@dh/dh-for-vue'
import DhForBoot from "@dh/dh-for-bootstrap"
import zhCn from "element-plus/es/locale/lang/zh-cn";
import ElementPlus from 'element-plus'
import plusZhCn from "plus-pro-components/es/locale/lang/zh-cn";
import {createDhForRouter} from "./router";
import mods from "./modules/mods";

// @ts-ignore
import 'element-plus/dist/index.css'
// @ts-ignore
import '@dh/dh-for-vue/style'
// @ts-ignore
import './style/main.scss'
// @ts-ignore
import "@dh/dh-for-bootstrap/style"
import DhForBootComp from "./components"

type ComponentModule = Record<string, any>;
const app = createApp(App)
const router = createDhForRouter({
    base: "merchant",
    layoutBase: 'l',
    fullBase: 'f',
    devModules: mods,
    vueRoutes: [],
    pages: {}
})
app.use(router);
app.use(ElementPlus, {
    locale: {...zhCn, ...plusZhCn}
})
// @ts-ignore
app.use(DhForVue, {dev: import.meta.env.DEV});

const components = DhForBootComp as unknown as ComponentModule;
for (const key in components) {
    //如果存在不覆盖
    if (app.component(key)) {
        continue;
    }
    app.component(key, components[key]);
}
const theme = localStorage.getItem("dh-for-admin-theme");
if (!theme) {
    shareTheme.sidebarStyle = 'LySlideBar';
    shareTheme.layoutStyle = 'padding';
    shareTheme.themeTemplate = 3;
    shareTheme.themeColor = 'police-blue';
}
shareTheme.themes = [
    {name: 'police-blue', value: '#0c2386', label: '警察蓝'},
    {name: 'cyan', value: '#44c1e3', label: '青色'},
    {name: 'lightBlue', value: '#3ea1f7', label: '浅蓝色'},
    {name: 'blue', value: '#5283ff', label: '蓝色'},
    {name: 'indigo', value: '#6647ff', label: '靛蓝色'},
    {name: 'deepPurple', value: '#ab19ff', label: '深紫色'},
    {name: 'purple', value: '#d23ce6', label: '紫色'},
    {name: 'pink', value: '#fc3d6d', label: '粉色'},
    {name: 'red', value: '#f55442', label: '红色'},
    {name: 'deepOrange', value: '#ff7919', label: '深橙色'},
    {name: 'orange', value: '#fa9e00', label: '橙色'},
    {name: 'yellow', value: '#f7c600', label: '黄色'},
    {name: 'lime', value: '#b9d433', label: '青柠色'},
    {name: 'lightGreen', value: '#82b51b', label: '浅绿色'},
    {name: 'green', value: '#42b33e', label: '绿色'},
    {name: 'teal', value: '#40bd93', label: '青蓝色'},
    {name: 'gray', value: '#405870', label: '灰色'}
];
app.use(DhForBoot);
app.mount('#app')

